export default class TradeInUtils {
    static validateTradeIn(record) {
        const {
            acv, allowance, vehicle,
        } = { ...record };
        const { miles, vin } = { ...vehicle };
        return acv > 0 && allowance > 0 && miles > 0 && vin?.length === 17;
    }
}
